//Customer
export const AppClientGetCustomer = '/customer';
export const AppClientAddAddress = '/customer/address';

//Cart
export const AppClientRemoveAllCartItems = '/cart';


//Order Summary
export const AppClientGetOrderSummary = '/OrderSummary/getOrderSummary';
